<template>
    <el-popconfirm
        :title="title"
        :confirmButtonText="confirmText"
        :cancelButtonText="cancelText"
        :icon="icon"
        :iconColor="iconColor"
        @confirm="$emit('confirm')"
        @cancel="$emit('cancel')">
        <template #reference>
            <slot />
        </template>
    </el-popconfirm>
</template>

<script>
export default {
    props: {
        title: { type: String, default: 'Are you sure?' },
        confirmText: { type: String, default: 'Yes' },
        cancelText: { type: String, default: 'Nevermind' },
        icon: { type: String, default: 'el-icon-info' },
        iconColor: { type: String, default: 'red' },
    },
}
</script>

<style scoped>
div {
    display: inline-block;
}
</style>